
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RepoSshAccess',
  props: {
    encPublicKey: {
      type: String,
      default: ''
    },
    updateSshKeyGenPending: {
      type: Boolean,
      default: false
    }
  }
})
